interface IPlanGroupProps {
  children: React.ReactNode;
}

const PlanGroup: React.FC<IPlanGroupProps> = ({ children }) => {
  return (
    <div className="tw-flex tw-w-full tw-flex-row tw-items-center tw-justify-center tw-gap-2 desktop:tw-gap-4">
      {children}
    </div>
  );
};

export default PlanGroup;
